import { csx } from '@vtex/admin-ui'
import type { DefaultProps } from 'typings'

interface Props extends DefaultProps {
  className?: string
}

const fullWidth = csx({ width: 'full' })

export function Full(props: Props) {
  return (
    <div className={[fullWidth, props.className].join('')}>
      {props.children}
    </div>
  )
}
